export default {
	methods: 
    {	
		filterSelects(list)
		{
			return _.filter(this.lists[list],['id_list_estado',1])
		},
		nuevoModal()
		{
		  this.resetDataIndex()
		  this.updateGlobal({state: 'openModal/modal/value',    data: true });
		  this.updateGlobal({state: 'openModal/modal/title',    data: 'Crear registro'});
		  this.updateGlobal({state: 'openModal/modal/modal',    data: 'Nuevo'});
		},
		getPdf()
		{
			let asesor=this.filter.id_datos_asesor
			if(asesor!==null)
			{
				asesor=asesor.id
			}
			let razon=this.filter.id_datos_razon
			if(razon!==null)
			{
				razon=razon.id
			}
			window.open( this.url+'/api/pdf/registrosaportes?desde='+this.filter.inicial+'&hasta='+this.filter.final+'&asesor='+asesor+'&razon='+razon+'&token='+this.token,'_blank')
		},
		async getFiltrar()
		{
			let dataRoute={}
			let others=[]
			let filterKeys= Object.keys(this.filter);
			for (let i = 0; i < filterKeys.length; i++) {
				if(filterKeys[i]==='inicial')
				{
					(this.filter.inicial==='') ? dataRoute.inicial= this.fecha().inicioLabores.servicios : dataRoute.inicial= this.filter.inicial;
					
				}		
				if(filterKeys[i]==='final')
				{
					(this.filter.final==='') ? dataRoute.final= this.fecha().inicioLabores.servicios : dataRoute.final= this.filter.final;
				}	
				if(filterKeys[i]!=='inicial' && filterKeys[i]!=='final' && this.filter[filterKeys[i]]!==''  && this.filter[filterKeys[i]]!==null)
				{
					others.push([filterKeys[i],this.filter[filterKeys[i]].id ])
				}	
			}
			dataRoute.others=others
			await this.getDataGet({ route: 'get_aportesregistros', data: dataRoute})
			//frontend await this.searchGetIdb({tabla:'afiliacion_registro', campo:'id_datos_asesor', value: this.filter.servicios.id})
		},	
		async getLimpiar()
		{
			this.filter = {
				inicial:this.fecha().fecha.minHoy,
				final: this.fecha().fecha.minHoy,
				id_datos_asesor: null,
				id_datos_razon: null
			}
			
			await this.getDataGet({route: 'get_aportesregistros', data: { inicial: this.fecha().fecha.minHoy, final: this.fecha().fecha.minHoy, others: []}})
			// frontend await this.searchGetIdb({tabla:'afiliacion_registro'})
		}
	},
}